import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

export const TooltipWrapper = ({ content, children, placement = "top" }) => {

    return (
        <OverlayTrigger
            placement={placement}
            overlay={<Tooltip>{content}</Tooltip>}>

            {children}
        </OverlayTrigger>
    );
};
